import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { colors } from "../../component/data/data";
import logo from "../../assets/images/abstract.png";
import "../../component/styles/styles.scss";

export default function Header() {
    const [active, setActive] = useState("");
    const location = useLocation();
    const sectionIds = [
        "premium-color-pallete-wrapper",
        "red-color-pallete-wrapper",
        "green-color-pallete-wrapper",
        "blue-color-pallete-wrapper",
        "yellow-color-pallete-wrapper",
        "mix-color-pallete-wrapper",
    ];

    const handleColorPalette = (i) => {
        setActive(i);
        const sectionId = sectionIds[i];
        const section = document.getElementById(sectionId);

        if (section) {
            section.scrollIntoView({
                behavior: "smooth",
            });
        }
    };

    const handleScrollTop = () => {
        window.scrollTo(0, 0);
        setActive("");
    };

    const renderButtonsBasedOnRoute = () => {

        const appLinks = [
            {
                linkText: "Solid",
                link: "/"
            },
            {
                linkText: "Gradient",
                link: "/gradient"
            },
            {
                linkText: "Image Picker",
                link: "/color_extractor"
            },
            {
                linkText: "Explorer",
                link: "/explorer"
            }
        ]


        return (
            <>
                <ul className='nav-links'>
                    {appLinks.map((items, index) => {
                        return (
                            <li key={index} onClick={handleScrollTop}>
                                <Link to={items.link} style={location.pathname === items.link ? { borderBottom: "1px solid #2b4d7a", color: "#2b4d7a" } : { borderBottom: 0, color: "#000" }}>{items.linkText}</Link>
                            </li>
                        )
                    })}
                </ul>
            </>
        )
    }


    return (
        <div className="pos-fixed">
            <h1>ShadeSense <img src={logo} alt="App logo" /></h1>
            <div className="w-100 d-flex justify-content-end align-items-center">
                {location.pathname === "/" && (
                    <ul>
                        {colors.map((colorCode, index) => {
                            return (
                                <li
                                    key={index}
                                    style={{ backgroundColor: colorCode.code }}
                                    onClick={() => handleColorPalette(index)}
                                    className={active === index ? "active" : ""}
                                >
                                </li>
                            );
                        })}
                    </ul>
                )}
                {renderButtonsBasedOnRoute()}
            </div>
        </div >
    )
}
